module.exports = __webpack_public_path__ + "img/p3.b04f8152.png";